var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_606_3314)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.22559,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2667 1.22559H3.13333C1.95513 1.22559 1 2.18071 1 3.35892V15.0923C1 16.2705 1.95513 17.2256 3.13333 17.2256H21.2667C22.4449 17.2256 23.4 16.2705 23.4 15.0923V3.35892C23.4 2.18071 22.4449 1.22559 21.2667 1.22559Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5.49219H23.4V12.9589H1V5.49219Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5999 7.86236V10.5504C10.5999 11.297 9.88314 11.8944 8.99994 11.8944H6.8666C5.98553 11.8922 5.2666 11.2917 5.2666 10.5482V7.86023C5.2666 7.25009 5.74447 6.74023 6.40154 6.57489C6.59994 6.02023 7.21007 6.51729 7.93327 6.51729C8.66074 6.51729 9.2666 6.02343 9.465 6.57596C10.1199 6.74556 10.5999 7.25649 10.5999 7.86236Z",
    fill: "#D4AF2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6002 8.69238H11.6669V11.8924H10.6002V8.69238ZM4.2002 8.69238H5.26686V11.8924H4.2002V8.69238Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6002 10.8257H11.6669V11.8924H10.6002V10.8257ZM4.2002 10.8257H5.26686V11.8924H4.2002V10.8257Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6002 7.62549H11.6669V8.69215H10.6002V7.62549ZM4.2002 7.62549H5.26686V8.69215H4.2002V7.62549Z",
    fill: "#D4AF2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3335 7.62549H7.40016V9.22549H6.3335V7.62549ZM8.46683 9.75882H9.5335V11.3588H8.46683V9.75882Z",
    fill: "#AF010D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4668 7.62549H9.53346V9.22549H8.4668V7.62549Z",
    fill: "#AE6A3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3335 9.75879H7.40016V11.3588H6.3335V9.75879Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40016 7.62575L6.3335 6.55908H9.5335L8.46683 7.62575H7.40016Z",
    fill: "#AF010D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3999 5.49219H8.46657V6.55885H7.3999V5.49219Z",
    fill: "#D4AF2C"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.725586,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "#EEEEEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_606_3314"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.22559,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/spain.6185d458dd4111b4a917b8aa4d28f1e7.svg";
export { ForwardRef as ReactComponent };